import MessagesDropdown from 'components/navbar/top/MessagesDropdown';
import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { checkPermission } from 'utils/checkPermission';

const TopNavRightSideNavItem = () => {
  const { currentUser: userLogged } = useSelector(state => state.login);

  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center gap-2"
      as="ul"
    >
      {userLogged?.realEstateId && checkPermission('Messages', userLogged) && (
        <MessagesDropdown />
      )}
      <NotificationDropdown />
      <ProfileDropdown />
    </Nav>
  );
};

TopNavRightSideNavItem.propTypes = {
  socket: PropTypes.object,
  establishment: PropTypes.object
};

export default TopNavRightSideNavItem;
